// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.contactum_calculation_fields {\n    position: relative;\nlabel{\n        margin-bottom: 10px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
